import { Dialog, DialogTitle } from "@mui/material";
import { CircularProgress } from "@mui/material";

const LoadingDialog = ({ message, open }) => {
  return (
    <Dialog open={open}>
      <DialogTitle>{message}</DialogTitle>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          padding: "20px",
        }}
      >
        <CircularProgress />
      </div>
    </Dialog>
  );
};

export default LoadingDialog;
